import { routerMiddleware } from 'connected-react-router';
import { History, LocationState } from 'history';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import { Persistor } from 'redux-persist/es/types';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { authSagas } from 'state/auth/auth.sagas';
import { createRootReducer } from 'state/reducer';

export function* rootSaga() {
  yield all([authSagas()]);
}

export const storeCreator = (
  history: History<LocationState>
): { store: Store; persistor: Persistor } => {
  const sagaMiddleware = createSagaMiddleware();
  const enhancer = composeWithDevTools(
    applyMiddleware(routerMiddleware(history), sagaMiddleware)
  );

  const store = createStore(createRootReducer(history), enhancer);
  const persistor = persistStore(store);
  sagaMiddleware.run(rootSaga);

  return {
    store,
    persistor,
  };
};
